import { createContext } from 'react';
import * as stores from '../models';

const storesContext = createContext(stores);
storesContext.displayName = 'storesContext';
export default storesContext;
